import { cn } from '@shared/lib/cn';

/**
 * Emergency SOS glyph — white "SOS" on a solid red disc. Shown in place of the
 * normal icon + label for the Panic module (home grid tile + bottom tab) so the
 * emergency action reads instantly and never blends in with regular modules.
 */
export function PanicSosBadge({ className }: { className?: string }): JSX.Element {
  return (
    <span
      role="img"
      aria-label="SOS"
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full bg-danger font-display font-bold leading-none tracking-wide text-white',
        className,
      )}
    >
      SOS
    </span>
  );
}
